import { useState } from "react";
import axios from "axios";
import { Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtErr = (detail) => {
  if (detail == null) return "No se pudo iniciar sesión. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

export const Login = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      onSuccess(data);
    } catch (err) {
      setError(fmtErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#101f18] px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#3a7a50] text-2xl font-bold text-white">T</div>
          <h1 className="mt-4 text-xl font-bold text-white">{`Tenjara Lombok CRM`}</h1>
          <p className="mt-1 text-sm text-white/50">Jade Residence · Acceso para el equipo</p>
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-2xl bg-white p-6 shadow-2xl" data-testid="login-form">
          <div>
            <label className="mb-1 block text-xs font-medium uppercase tracking-wide text-gray-500">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              autoComplete="email"
              className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm outline-none transition-colors focus:border-[#2d5a3d] focus:ring-2 focus:ring-[#2d5a3d]/15"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@tenjaralombok.com"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium uppercase tracking-wide text-gray-500">Contraseña</label>
            <input
              data-testid="login-password"
              type="password"
              required
              autoComplete="current-password"
              className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm outline-none transition-colors focus:border-[#2d5a3d] focus:ring-2 focus:ring-[#2d5a3d]/15"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          {error && <p data-testid="login-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#2d5a3d] py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#3a7a50] disabled:opacity-60"
          >
            <Lock className="h-4 w-4" />
            {loading ? "Entrando..." : "Entrar al CRM"}
          </button>
        </form>
        <p className="mt-6 text-center text-[11px] text-white/30">Acceso restringido al equipo de Tenjara Lombok</p>
      </div>
    </div>
  );
};
